var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12.57v-1.148l1.44-1.26a1.5 1.5 0 0 0 .285-1.912l-1.77-3a1.5 1.5 0 0 0-1.298-.75 1.5 1.5 0 0 0-.48.075l-1.822.615a8.5 8.5 0 0 0-.983-.563l-.382-1.89a1.5 1.5 0 0 0-1.5-1.207h-3.51a1.5 1.5 0 0 0-1.5 1.207l-.383 1.89a8.61 8.61 0 0 0-.99.563l-1.785-.645a1.5 1.5 0 0 0-.48-.045 1.5 1.5 0 0 0-1.297.75l-1.77 3a1.5 1.5 0 0 0 .307 1.882L3.75 11.43V12.577l-1.418 1.26a1.5 1.5 0 0 0-.307 1.913l1.77 3a1.5 1.5 0 0 0 1.297.75 1.5 1.5 0 0 0 .48-.075l1.823-.615c.315.209.643.397.982.562l.383 1.89a1.5 1.5 0 0 0 1.5 1.208h3.54a1.5 1.5 0 0 0 1.5-1.208l.382-1.89c.342-.165.673-.353.99-.562l1.815.615a1.5 1.5 0 0 0 .48.075 1.501 1.501 0 0 0 1.298-.75l1.71-3a1.5 1.5 0 0 0-.308-1.883L20.25 12.57zM18.907 18l-2.572-.87c-.602.51-1.29.909-2.033 1.177L13.77 21h-3.54l-.533-2.663a7.018 7.018 0 0 1-2.025-1.177l-2.58.84-1.77-3 2.04-1.8a6.675 6.675 0 0 1 0-2.348L3.322 9l1.77-3 2.573.87a6.645 6.645 0 0 1 2.032-1.178L10.23 3h3.54l.532 2.662c.737.277 1.421.675 2.025 1.178l2.58-.84 1.77 3-2.04 1.8a6.674 6.674 0 0 1 0 2.347L20.677 15l-1.77 3z",
    fill: "#020002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5a4.5 4.5 0 1 1 4.5-4.5 4.456 4.456 0 0 1-4.5 4.5zM12 9a2.933 2.933 0 0 0-3 3 2.933 2.933 0 0 0 3 3 2.933 2.933 0 0 0 3-3 2.933 2.933 0 0 0-3-3z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBlack);
export default __webpack_public_path__ + "static/media/settings_black.711b6fed629961a4ef0f672ed9b4fb98.svg";
export { ForwardRef as ReactComponent };